import Vue from "vue"
import Vuex from "vuex"

// 引入 axios
import axios from '../config/httpConfig'
import state from './state';

Vue.use(Vuex);

function convertToObj(obj){
  if(obj){
      return JSON.parse(obj);
  }
  return null;
}

export default new Vuex.Store({
  state,
  mutations: {
    setToken(state, userToken) {
      state.token = userToken;
      sessionStorage.setItem('token', userToken);
    },

    setAccountType(state, accuntType) {
      state.accuntType = accuntType;
      sessionStorage.setItem('accuntType', accuntType);
    },

    getUserInfo(state, userInfo) {
      if(userInfo.IsExpert == undefined){
        userInfo.IsExpert = false;
      }
      if(userInfo.ImgUrl==null || userInfo.ImgUrl==""){
        userInfo.ImgUrl ="../../../static/personalCenter/avator.png";
      }else{
        userInfo.ImgUrl =Glod.UrlPrefix+userInfo.ImgUrl;
      }
      
      state.userInfo = userInfo;
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    },

    setIndex(state, tabIndex) {
      state.tabIndex = tabIndex;
      sessionStorage.setItem('tabIndex', tabIndex);
    }
  },
  actions: {
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js